module.exports = __webpack_public_path__ + "_assets/img/Frame1213.aa105554.svg";